import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { UserRole } from "../../../@types/userRole";
import axiosInstance from "../../../utils/axiosConfig";
export const findUserRoles = createAsyncThunk(
  "organization/findUserRoles",
  async (idOrganization: string, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(`${api.baseURL}userrole`, {
        params: {
          where: {
            organization: idOrganization,
            enabled: true,
          },
        },
      });
      return data as UserRole[];
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
